import {
  CommentDTOInterface,
  CompanyStationInterface,
  ComplaintAcceptInterface,
  ComplaintCommentCreateInterface,
  ComplaintCreateModelInterface,
  ComplaintListModelInterface,
  ComplaintListQueryInterface,
  ComplaintModelInterface,
  ContractSearchQueryInterface,
  ContractSearchResultInterface,
  ContractSheetQueryInterface,
  ContractSheetShortModelInterface,
  idParamsInterface,
  IPaginatorData,
} from '@elearning-platform/api-types/interfaces';
import { stringify } from 'query-string';

import { api } from '../api';

export const getComplaints: (params: ComplaintListQueryInterface) => Promise<IPaginatorData<ComplaintListModelInterface>> = (
  params: ComplaintListQueryInterface
): Promise<IPaginatorData<ComplaintListModelInterface>> => api.get(
  `/complaints?${stringify(params, { skipEmptyString: true })}`
);

export const getComplaintDetails: (id: number) => Promise<ComplaintModelInterface> = (
  id: number
): Promise<ComplaintModelInterface> => api.get(`/complaints/${id}`);

export const acceptComplaint: (id: number, data: ComplaintAcceptInterface | Record<never, never>) => Promise<ComplaintModelInterface> = (
  id: number, data: ComplaintAcceptInterface | Record<never, never>
): Promise<ComplaintModelInterface> => api.post(`/complaints/${id}/accept`, data);

export const rejectComplaint: (id: number) => Promise<ComplaintModelInterface> = (
  id: number
): Promise<ComplaintModelInterface> => api.post(`/complaints/${id}/reject`);

export const searchContractsForComplaint: (params: ContractSearchQueryInterface) => Promise<ContractSearchResultInterface[]> = (
  params: ContractSearchQueryInterface
): Promise<ContractSearchResultInterface[]> => api.get(
  `/complaints/contracts/search?${stringify(params, { skipEmptyString: true })}`
);

export const createComplaint: (data: ComplaintCreateModelInterface) => Promise<ComplaintModelInterface> = (
  data: ComplaintCreateModelInterface
): Promise<ComplaintModelInterface> => api.post('/complaints', data);

export const addContractToComplaint: (complaintId: number, data: idParamsInterface<number>) => Promise<ComplaintModelInterface> = (
  complaintId: number, data: idParamsInterface<number>
): Promise<ComplaintModelInterface> => api.post(`/complaints/contracts/${complaintId}`, data);

export const addComplaintComment: (complaintId: number, data: ComplaintCommentCreateInterface) => Promise<CommentDTOInterface> = (
  complaintId: number, data: ComplaintCommentCreateInterface
): Promise<CommentDTOInterface> => api.post(`/complaints/comments/${complaintId}`, data);

export const deleteComplaintComment: (commentId: number) => Promise<CommentDTOInterface> = (
  commentId: number
): Promise<CommentDTOInterface> => api.delete(`/complaints/comments/${commentId}`);

export const getComplaintsStations: () => Promise<CompanyStationInterface[]>
  = (): Promise<CompanyStationInterface[]> => api.get('/complaints/stations');

export const searchComplaintsSheets: (params: ContractSheetQueryInterface) => Promise<ContractSheetShortModelInterface[]> = (
  params: ContractSheetQueryInterface
): Promise<ContractSheetShortModelInterface[]> => api.get(`/complaints/sheets?${stringify(params, { skipEmptyString: true })}`);
